import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  Input,
  OnDestroy
} from '@angular/core';
import { FormControl } from "@angular/forms";
import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { CommonService } from "./../../../services/common.service";
import { MessageService } from './../../../services/message-service';
import { environment } from "./../../../../../environments/environment";
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'mobile-auto-complete',
  templateUrl: './mobile-auto-complete.component.html',
  styleUrls: ['./mobile-auto-complete.component.scss']
})
export class MobileAutoCompleteComponent implements OnInit, OnChanges, OnDestroy {

  @Input() filterInfo;
  @Output() dataSelected: EventEmitter<any> = new EventEmitter();
  @Input() optionSelected = "";
  baseUrl = environment.gateWayHost;

  autoCompleteField = new FormControl();
  autoCompleteInput = new Subject();
  filteredOptions = [];
  valueSelected = "";
  fieldReadOnly = false;
  debounceTimer = null;
  private unsubscribe: Subject<void> = new Subject();

  constructor(private commonService: CommonService, private message: MessageService) { }

  ngOnInit() {
    this.autoCompleteField.valueChanges
      .pipe(debounceTime(500))
      .subscribe((response: any) => {
        if (this.filterInfo) {
          this.filterInfo.valueObject = this.optionSelected;

          if (!response || typeof response !== "string") {
            return (this.filteredOptions = []);
          }
          const queryParams = { query_string: response };

          this.getAutoCompleteData(queryParams);
        }

      });
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  getAutoCompleteData(queryParams) {
    if (this.filterInfo.queryParams && Object.keys(this.filterInfo.queryParams).length) {
      queryParams = { ...queryParams, ...this.filterInfo.queryParams };
    }

    const options = {
      method: "GET",
      query: queryParams,
      url: `${this.baseUrl}${this.filterInfo.api}`
    };
    this.commonService.getData(options).pipe(takeUntil(this.unsubscribe)).subscribe(
      (response: any) => {
        this.filteredOptions =
          response["data"] && Array.isArray(response["data"])
            ? response["data"]
            : [];
      },
      error => {
        this.filteredOptions = [];
      }
    );
  }

  displayFn(data?) {
    let value = "";
    let displayData = "";
    if (data) {
      this.filterInfo.config['display'].split(' ').map((_display, index) => {
        if (index > 0) {
          displayData += ' : ';
        }
        displayData += _display.split(".").reduce(function (p, prop) {
          return p[prop];
        }, data);
      });

      // displayData = this.config["display"].split(".").reduce(function (p, prop) {
      //   return p[prop];
      // }, data);

      value = this.filterInfo.config["value"].split(".").reduce(function (p, prop) {
        return p[prop];
      }, data);
    }
    this.valueSelected = value || undefined;
    this.fieldReadOnly = value ? true : false;
    if (this.filterInfo) {
      this.filterInfo.valueObject = this.optionSelected;
      this.filterInfo.value = displayData;
      this.dataSelected.emit(this.filterInfo);
    }


    return displayData || undefined;
  }

  channelAutocomplete(value) {
    if (!value || value.length < 3) {
      this.filteredOptions = [];
      return;
    }
    const params = { query_string: value };
    this.autoCompleteInput.next(params);
  }

  displayDropDown(data) {
    let value = ""
    this.filterInfo.config["display"].split(" ").map(function (field, index) {
      value += field.split(".").reduce(function (p, prop) {
        if (index && prop !== "fields") {
          return ` - ${p[prop]}`;
        }
        return p[prop];
      }, data);
    })
    // const value = this.config["display"].split(".").reduce(function(p, prop) {
    //   return p[prop];
    // }, data);
    return value;
  }

  setAutoCompleteData($event) {
    if ($event && $event.option && $event.option.value) {

    }
  }

  deleteSelectedValue() {
    this.valueSelected = "";
    this.optionSelected = null;
    this.autoCompleteField.reset();
    this.fieldReadOnly = false;
    this.filterInfo.valueObject = null;
    this.filterInfo.value = "";
    this.dataSelected.emit(this.filterInfo);
    //this.textValueEmit.emit({ model: this.model, value: null });
  }

  ngOnDestroy() {
    this.valueSelected = "";
    this.autoCompleteField.reset();
    this.fieldReadOnly = false;
    this.optionSelected = null;
    this.filterInfo = null;
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
